'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

___$insertStyle(".accordion .title {\n  padding-top: 28px;\n  padding-bottom: 28px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  /* 125% */\n}\n.accordion .content {\n  animation-name: accordionContent;\n  animation-duration: 1s;\n  overflow: hidden;\n  margin-bottom: 28px;\n}\n\n.accordion-group .accordion {\n  border-top: 1px dashed rgba(29, 102, 221, 0.1);\n}\n.accordion-group .accordion:last-child {\n  border-bottom: 1px dashed rgba(29, 102, 221, 0.1);\n}\n\n@keyframes accordionContent {\n  0% {\n    max-height: 0;\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    max-height: 500px;\n  }\n}");
//# sourceMappingURL=Accordion.scss.js.map
